export enum Compression {
    None = 'none',
    Gzip = 'gzip',
    Zstd = 'zstd',
}